export const HOME = 'home';
export const ONBOARDING = 'onboarding';
export const VERIFICATION = 'verification';
export const DASHBOARD = 'dashboard';
export const COMMON = 'common';
export const SERVICES = 'services';

export const AVAILABLE_LANGUAGES = {
  en: 'en',
  ar: 'ar'
};

export interface LanguageOption {
  code: string;
  label: string;
  nativeLabel: string;
}

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: AVAILABLE_LANGUAGES.en, label: 'English', nativeLabel: 'English' },
  { code: AVAILABLE_LANGUAGES.ar, label: 'Arabic', nativeLabel: 'العربية' }
];

export const DEFAULT_LNG = AVAILABLE_LANGUAGES.en;
export const LANGUAGES = [AVAILABLE_LANGUAGES.en, AVAILABLE_LANGUAGES.ar];
export const DEFAULT_NS = 'common';
export const COOKIE_NAME = 'portalLang';
/** Milliseconds per day (24 * 60 * 60 * 1000), for cookie expiry etc. */
export const MS_PER_DAY = 24 * 60 * 60 * 1000;
export const CO_BRAND_CLIENT_ID = 'clientId';
export const CO_BRAND_SUBDOMAIN_COOKIE_NAME = 'coBrandSubDomain';

export const ACKNOWLEDGE_THROUGH = {
  SIGNATURE: 'signature'
};

export const DATAFLOW_EMAIL_SUFFIX = '@dataflowgroup.com';
export const CO_BRAND_COOKIE_PATH_NAME = 'coBrandPathName';
